import PropTypes from 'prop-types';

import EspecialitatsList from '../../Especialitats/EspecialitatsList';

const EspecialitatsListingTemplate = ({ items, isEditMode }) => (
  <div className="listing variation-especialitats">
    <EspecialitatsList items={items} isEditMode={isEditMode} />
  </div>
);

EspecialitatsListingTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
};

EspecialitatsListingTemplate.defaultProps = {
  items: [],
  isEditMode: false,
};

export default EspecialitatsListingTemplate;
